import Layout from "../../../components/Layout/Layout";
import BreadCrumb from "../../../components/BreadCrumb/Breadcrumb";
import { useEffect, useState } from "react";
import { TableSearch } from "../../../components/Table/TableActions";
import Table from "../../../components/Table/Table";
import { Icon } from "@iconify/react";
import Badge from "../../../components/Badge/Badge";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button/Button";

// --Dummy data
import SChoolApiData from "../../../dummy_data/schoolapi.json";

const SchoolApiInfo = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };
  const columns = [
    {
      name: "API Calls",
      selector: row => row?.api_call
    },
    {
      name: "API status",
      center: true,
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "API Usage",
      selector: row => row?.api_usage
    },
    {
      name: "Price per query",
      selector: row => row?.price_per_query
    },
    {
      name: "Cost",
      selector: row => row?.cost
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    // The data will be from the inventory get api endpint
    setSearchResult(SChoolApiData);
  }, []);

  // --| Filter Shelf21 table using name, email and class
  const handleAdminSchools = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = SChoolApiData?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                    data?.description
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                    data?.category
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                      data?.status
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <BreadCrumb
            link_one="/latency-test"
            link_one_name="Latency Test"
            active="Great Academy API Calls"
            description="See the API calls made by Great Academy"
          />
          <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
            <TableSearch placeholder="Search here..." searchTableFunc={handleAdminSchools} />
          }
          />
          {/* Delete Modal */}
          <Modal
            title="Delete API Call"
            subtitle={
              <div>Are you sure you want to remove <span className="modal-name-highlight">{currentRow?.contractor}</span>. from one of your calls? Removing it will permanently clear all this records.`
              </div>}
            modalContent={
              <>

              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="dangeroutline"
                    buttonSize="full"
                    color="btndanger"
                    buttonName="Cancel"
                  />
                  <Button variant="danger" buttonName="Remove Contractor" buttonSize="full" color="btndefault" />
                </div>
              </>
            }
            isopen={deleteModal}
            closeModal={handleDeleteModal}
          />
        </>
      }
    />
  );
};

export default SchoolApiInfo;
